import React, {Component} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GraficBatalla from './GraficBatalla'

//cal rebre a través de props: resultats



class Batalla extends Component {
    
    retornaResultatCandidatura(candidatura) {

        var vots_per = 0;
        this.props.resultatsCandidatures.forEach(element => {
            
            if (element.codi===candidatura) {
                vots_per = element.vots_per; //Si el codi coincideix amb el passat, retorna els valors de percentatge
            } 
        });   
    
        return vots_per;
    
    }

    render() {          

     return (
        <div>
            <Row className="batalles">
            <Col>
                <h3>Batalles</h3>
            </Col>
        </Row>

        <Row className="batalles">
        <Col md={6}>
                <h5>El model de país</h5>
                <p>Comparació de les candidatures de PDeCAT, ERC, CUP i JxCat contra C's, PSC, PP i VOX</p>
                <GraficBatalla batalla colorResultat1="#D89D0C" colorResultat2="#A61700" resultat1={this.retornaResultatCandidatura(10)+this.retornaResultatCandidatura(1097)+this.retornaResultatCandidatura(1098)+this.retornaResultatCandidatura(1083)} resultat2={this.retornaResultatCandidatura(6)+this.retornaResultatCandidatura(86)+this.retornaResultatCandidatura(301)+this.retornaResultatCandidatura(693)}/>
            </Col>
            
            <Col md={6}>
                <h5>Les escissions de Convergència</h5>
                <p>Comparació dels vots de JxCat i PDeCAT sobre la suma de les dues candidatures</p>
                <GraficBatalla duel colorResultat1="#00FFBF" colorResultat2="#1963E6" resultat1={this.retornaResultatCandidatura(1083)} resultat2={this.retornaResultatCandidatura(1097)}/>
            </Col>


        </Row>
        </div>   
      );
    }
  }

  export default Batalla;